//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { VueTabs, VTab } from 'vue-nav-tabs/dist/vue-tabs.js'
import ModalDistributors from '~/components/base/ui/ModalDistributors.vue'

export default {
  nuxtI18n: {
    paths: {
      br: '/produtos/:category/:subcategory/:product',
      en: '/products/:category/:subcategory/:product',
      es: '/productos/:category/:subcategory/:product'
    }
  },

  components: {
    VueTabs,
    VTab,
    ModalDistributors
  },

  async asyncData({ $api, params }) {
    try {
      // Get product
      const { product: slug } = params
      const response = await $api.products.show(slug)
      const product = response.product || {}
      const products_related = response.products_related || []
      const application_tools = response.application_tools || []
      const applications = response.applications || []
      const publication_links = response.publication_links || []
      const links = response.links || []
      const news = response.news || []
      const badges = response.badges || product.badges || []
      const faqs = response.faqs || product.faqs || []

      product.badges =
        product.badges && product.badges.length > 0 ? product.badges : badges
      product.faqs =
        product.faqs && product.faqs.length > 0 ? product.faqs : faqs

      // Handle medias
      if (product.main_image) {
        product.medias = [product.main_image, ...product.medias]
      }

      return {
        product,
        products_related,
        application_tools,
        applications,
        publication_links,
        links,
        news,
        badges: product.badges,
        faqs: product.faqs
      }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      product: {},
      publication_links: [],
      products_related: [],
      application_tools: [],
      applications: [],
      links: [],
      news: [],
      badges: [],
      faqs: [],
      tabName: '',
      showDistributorsModal: false,
      isCustomContentOpen: false,
      tutorialVideo: {
        display: false,
        show: false,
        url: ''
      },
      slideItTabsItemsConfig: {
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2.1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.8,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 476,
            settings: {
              slidesToShow: 1.3,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },

  head() {
    const { title, seo, main_image, faqs } = this.product

    const headConfig = this.$helpers.seoBuilder(this, {
      staticTitle: seo ? seo.title : title || this.$t('title'),
      staticDescription: seo ? seo.description : null,
      ogImage: main_image ? main_image.url : null,
      ogImageWidth: main_image ? 771 : null,
      ogImageHeight: main_image ? 428 : null
    })

    if (faqs && faqs.length > 0) {
      headConfig.script = headConfig.script || []
      headConfig.script.push({
        hid: 'faq-jsonld',
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.answer
            }
          }))
        }
      })
    }

    return headConfig
  },

  computed: {
    ...mapGetters({
      layout: 'layout/getLayout'
    }),

    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/produtos'
        }
      ]

      if (this.product.category) {
        // Push category breadcrumb
        breadcrumbs.push({
          name: this.product.category.title,
          path: `/produtos/${this.product.category.slug}`
        })

        if (this.product.sub_category) {
          // Push subcategory breadcrumb
          breadcrumbs.push({
            name: this.product.sub_category.title,
            path: `/produtos/${this.product.category.slug}/${this.product.sub_category.slug}`
          })

          // Push product breadcrumb
          breadcrumbs.push({
            name: this.product.title,
            path: this.$route.fullPath
          })
        }
      }

      return breadcrumbs
    },

    whatsapp() {
      const { others } = this.layout
      const { whatsapp_products_status, whatsapp_products } = others

      return {
        active: whatsapp_products_status === '1',
        phone: whatsapp_products,
        message:
          'Olá, gostaria de saber um pouco mais sobre os produtos da Intelli'
      }
    },

    showTabs() {
      const hasApplicationTools =
        this.application_tools && this.application_tools.length > 0
      const hasApplications = this.applications && this.applications.length > 0
      const hasLinks = this.links && this.links.length > 0
      const hasNews = this.news && this.news.length > 0
      const hasPublication_links =
        this.publication_links && this.publication_links.length > 0

      return (
        hasApplicationTools ||
        hasApplications ||
        hasLinks ||
        hasNews ||
        hasPublication_links
      )
    }
  },

  methods: {
    openTutorialVideo(url) {
      this.tutorialVideo.display = !this.tutorialVideo.display
      this.tutorialVideo.url = url

      setTimeout(() => {
        this.tutorialVideo.show = !this.tutorialVideo.show
      }, 200)
    },

    closeTutorialVideo() {
      this.tutorialVideo.show = !this.tutorialVideo.show
      this.tutorialVideo.url = ''

      setTimeout(() => {
        this.tutorialVideo.display = !this.tutorialVideo.display
      }, 300)
    },

    openDistributorsModal() {
      console.log('Product object:', this.product)
      console.log('Product code:', this.product.code)
      console.log('Product code type:', typeof this.product.code)
      console.log('Product code === 0:', this.product.code === 0)
      console.log('Product code === "0":', this.product.code === "0")
      console.log('Product object keys:', Object.keys(this.product))
      
      // Vamos verificar se existe outra propriedade com o código
      console.log('Product id:', this.product.id)
      console.log('Product slug:', this.product.slug)
      console.log('Product sku:', this.product.sku)
      console.log('Product reference:', this.product.reference)
      
      this.showDistributorsModal = true
    },

    closeDistributorsModal() {
      this.showDistributorsModal = false
    },

    toggleCustomContent() {
      this.isCustomContentOpen = !this.isCustomContentOpen
    },

    accordionBeforeEnter(el) {
      el.style.height = '0'
      el.style.opacity = '0'
    },

    accordionEnter(el) {
      el.style.transition = 'height 300ms ease, opacity 250ms ease'
      el.style.height = `${el.scrollHeight}px`
      el.style.opacity = '1'
    },

    accordionAfterEnter(el) {
      el.style.height = 'auto'
    },

    accordionBeforeLeave(el) {
      el.style.height = `${el.scrollHeight}px`
      el.style.opacity = '1'
    },

    accordionLeave(el) {
      el.style.transition = 'height 300ms ease, opacity 200ms ease'
      // Force reflow
      // eslint-disable-next-line no-unused-expressions
      el.offsetHeight
      el.style.height = '0'
      el.style.opacity = '0'
    },

    accordionAfterLeave(el) {
      el.style.height = '0'
    }
  }
}
